import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GraduateUserFromRoadmap extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("RoadMapGroup/Graduated");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export { GraduateUserFromRoadmap };
